"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports.wrapRootElement = void 0;

var _react = _interopRequireDefault(require("react"));

var _appProviders = require("./components/app-providers");

var _jsxFileName = "/home/circleci/project/src/gatsby-browser.js";

var wrapRootElement = function wrapRootElement(_ref, pluginOptions) {
  var element = _ref.element;
  return _react.default.createElement(_appProviders.AppProviders, {
    element: element,
    pluginOptions: pluginOptions,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 8
    },
    __self: this
  });
};

exports.wrapRootElement = wrapRootElement;